
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.84 12.652c-.56-.14-1.12-.42-1.54-.84-.42-.14-.56-.56-.56-.84 0-.28.14-.7.42-.84.42-.28.84-.56 1.26-.42.84 0 1.54.42 1.96.98l1.26-1.68c-.42-.42-.84-.7-1.26-.98-.42-.28-.98-.42-1.54-.42v-1.96h-1.68v1.96c-.7.14-1.4.56-1.96 1.12-.56.7-.98 1.54-.84 2.38 0 .84.28 1.68.84 2.24.7.7 1.68 1.12 2.52 1.54.42.14.98.42 1.4.7.28.28.42.7.42 1.12 0 .42-.14.84-.42 1.26-.42.42-.98.56-1.4.56-.56 0-1.26-.14-1.68-.56-.42-.28-.84-.7-1.12-1.12l-1.4 1.54c.42.56.84.98 1.4 1.4.7.42 1.54.84 2.38.84v1.82h1.54v-2.1c.84-.14 1.54-.56 2.1-1.12.7-.7 1.12-1.82 1.12-2.8 0-.84-.28-1.82-.98-2.38-.7-.7-1.4-1.12-2.24-1.4zm-.84-9.8c-6.16 0-11.2 5.04-11.2 11.2 0 6.16 5.04 11.2 11.2 11.2 6.16 0 11.2-5.04 11.2-11.2 0-6.16-5.04-11.2-11.2-11.2zm0 20.86c-5.32 0-9.66-4.34-9.66-9.66s4.34-9.66 9.66-9.66 9.66 4.34 9.66 9.66-4.34 9.66-9.66 9.66z"}})])
          )
        }
      }
    